module.exports = __webpack_public_path__ + "edddebd2.webp";